export default "__VITE_ASSET__ne3U2YMs__"